import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0F2A2C] text-white">
      <div className="container-x py-16 lg:py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-5">
          <Logo variant="inverse" />
          <p className="text-white/70 text-[15px] leading-relaxed max-w-sm">
            A warm, person-centred NDIS provider supporting Australians to live with choice, dignity, and independence.
          </p>
          <div className="pill bg-white/5 border-white/15 text-white">
            <span className="h-1.5 w-1.5 rounded-full bg-[#7FD1CB] animate-soft-pulse" />
            NDIS Supports · Servicing Australia
          </div>
        </div>

        <div className="lg:col-span-2">
          <p className="eyebrow text-[#7FD1CB]">Explore</p>
          <ul className="mt-4 space-y-2.5 text-[15px] text-white/80">
            <li><Link to="/" className="underline-anim" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" className="underline-anim" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/services" className="underline-anim" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/referrals" className="underline-anim" data-testid="footer-link-referrals">Referrals</Link></li>
            <li><Link to="/contact" className="underline-anim" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-[#7FD1CB]">Talk to us</p>
          <ul className="mt-4 space-y-3 text-[15px] text-white/80">
            <li className="flex items-start gap-2.5"><Phone className="h-4 w-4 mt-1 text-[#7FD1CB]" /><a href="tel:0426635885" data-testid="footer-phone">0426 635 885</a></li>
            <li className="flex items-start gap-2.5"><Mail className="h-4 w-4 mt-1 text-[#7FD1CB]" /><a href="mailto:info@valorasupportservices.com" data-testid="footer-email">info@valorasupportservices.com</a></li>
            <li className="flex items-start gap-2.5"><MapPin className="h-4 w-4 mt-1 text-[#7FD1CB]" /><span>13 Appleberry Ave, Coomera QLD 4209<br/>Servicing all of Australia</span></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-[#7FD1CB]">Start your journey</p>
          <p className="mt-4 text-white/80 text-[15px]">Tell us about the supports you need — we'll get back within one business day.</p>
          <Link to="/referrals" data-testid="footer-cta" className="mt-5 inline-flex items-center gap-2 rounded-full bg-white text-[#0F2A2C] px-5 py-3 font-semibold hover:bg-[#E6FFFA] transition">
            Make an enquiry <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} Valora Support Services. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
            <a href="/privacy" data-testid="footer-link-privacy" className="hover:text-white">Privacy Policy</a>
            <a href="/terms" data-testid="footer-link-terms" className="hover:text-white">Terms &amp; Conditions</a>
            <span>13 Appleberry Ave, Coomera QLD 4209</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
